import React from "react";

import { ValueInput } from "@common/components/Input/ValueInput/ValueInput";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { ReleaseMetricScore } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import * as Styled from "main/pages/Release/views/MetricDetails/shared/MetricRow.styles";

export interface ThresholdRowModel {
  score?: number;
  label: string;
  value: number;
  error: string | undefined;
  onChange: (value: number) => void;
  description: string;
}

interface MetricRowProps {
  label?: string;
  value: number;
  unit?: string;
  step?: number;
  min?: number;
  isError?: boolean;
  error?: string;
  description: string;
  onChange: (value: number) => void;
  score?: number;
  showScore?: boolean;
}

export function MetricRow({
  label = "Threshold",
  value,
  unit,
  step,
  min,
  isError,
  error,
  description,
  onChange,
  score,
  showScore,
}: MetricRowProps) {
  const inputElement = (
    <ValueInput
      label={label}
      unit={unit}
      value={value}
      step={step}
      min={min}
      isError={isError ?? !!error}
      onChange={onChange}
    />
  );

  return (
    <Styled.MetricRowWrapper>
      {showScore ? (
        <Styled.ScoreAndInput>
          <Tooltip
            style={{ width: "auto" }}
            text={"Current score of this metric"}
            position={"top"}
          >
            <ReleaseMetricScore score={score} />
          </Tooltip>
          {inputElement}
        </Styled.ScoreAndInput>
      ) : (
        inputElement
      )}
      <Styled.DescriptionColumn>
        <Styled.DescText>{description}</Styled.DescText>
        {error && <Styled.ErrorText>{error}</Styled.ErrorText>}
      </Styled.DescriptionColumn>
    </Styled.MetricRowWrapper>
  );
}
